var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8129 6.35831L7.52436 0.286089C7.46841 0.239793 7.39703 0.213867 7.32179 0.213867H5.61445C5.47169 0.213867 5.4061 0.384238 5.51413 0.473126L12.2702 6.10276H0.980508C0.895623 6.10276 0.826172 6.16942 0.826172 6.2509V7.36201C0.826172 7.4435 0.895623 7.51016 0.980508 7.51016H12.2683L5.5122 13.1398C5.40417 13.2305 5.46976 13.399 5.61252 13.399H7.37774C7.41439 13.399 7.45105 13.3861 7.47806 13.362L14.8129 7.25461C14.8797 7.19886 14.9332 7.13001 14.9699 7.05269C15.0066 6.97538 15.0256 6.89142 15.0256 6.80646C15.0256 6.7215 15.0066 6.63753 14.9699 6.56022C14.9332 6.48291 14.8797 6.41406 14.8129 6.35831Z",
    fill: "#3879F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.25fb95bb224d6389e9ea0931829dbf1b.svg";
export { ForwardRef as ReactComponent };